import axios from "axios";

/**
 * เรียก API WorkOrder แบบไม่มี Auth
 */
export const getWorkOrderDocumentNoAuth = async (data) => {
    try {
        // กำหนด payload ตามเวอร์ชัน
        let payload = {};

        if (data.version === "fastcare") {
            payload = {
                client_id: data.client_id,
                project_id: data.project_id,
                module_type: "PROJECT",
                wo_status: "",
                is_not_filtered_user: "Y",
                version: 2
            };
        } else {
            if (!data.company_code || !data.project_ref_id) {
                return null;
            }
            payload = {
                company_code: data.company_code,
                project_ref_id: data.project_ref_id,
                module_type: "PROJECT",
                wo_status: "",
                is_not_filtered_user: "Y",
                version: 2
            };
        }

        const result = await axios({
            method: 'post',
            url: `${data.client_url}/api/v1/wo/get-work-order-document-no-auth`,
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': process.env.REACT_APP_FAST_X_API_KEY
            },
            data: payload
        });

        return result;
    } catch (error) {
        return error;
    }
};

/**
 * ฟังก์ชัน helper ดึง WorkOrder รายละเอียดตาม reference_code
 * @param {number} client_id
 * @param {string} client_url
 * @param {number} project_id
 * @param {string} reference_code
 * @returns {object|null} รายละเอียด WorkOrder
 */
export const getWorkOrderDetailByReferenceCode = async ({ client_id, client_url, project_id, company_code, project_ref_id, reference_code, version }) => {
    try {
        const res = await getWorkOrderDocumentNoAuth({ client_id, project_id, client_url , company_code, project_ref_id, version });
        
        if (res.status === 200) {
            const woList = res.data?.result?.wo || [];
            // เลือกรายการที่ตรงกับ reference_code
            const detail = woList.find(item => item.reference_code === reference_code);
            return detail || null;
        }

        return null;
    } catch (error) {
        console.error("getWorkOrderDetailByReferenceCode error:", error);
        return null;
    }
};

// ดึง wo_id และรายละเอียด work order
export const getWorkOrderInfoByReferenceCode = async ({ client_id, reference_code }) => {
    try {
        const res = await axios.get(`/work-order/detail`, {
            params: { client_id, reference_code }
        });
        return res.data; 
    } catch (error) {
        console.error(error);
        return { status: "error", message: error.message };
    }
};
   
// อัพเดต wo_status เป็น "P" เพื่อซ่อนปุ่ม Close Ticket กรณีที่ wo_status ไม่ใช่ "C"
export const saveWorkOrderStatus = async ({ client_id, work_order, client_url }) => {
  try {
    const result = await axios({
      method: "post",
      url: `${client_url}/api/v1/wo/save`, 
      headers: {
        "Content-Type": "application/json",
        "x-api-key": process.env.REACT_APP_FAST_X_API_KEY
      },
      data: {
        client_id,
        work_order 
      }
    });

    return result.data; 
  } catch (error) {
    console.error("saveWorkOrderStatus error:", error);
    return { status: "error", message: error.message };
  }
};
